<template>
    <router-link :to="link"
                 :class="['news-card', modify]">
        <div class="news-card__header">
            <div v-if="date"
                 class="news-card__date">
                {{ date }}
            </div>

            <div v-if="tag"
                 class="news-card__tag">
                {{ tag }}
            </div>
        </div>

        <div v-if="title"
             class="news-card__title"
             v-html="title" />
        <div class="news-card__link">
            <STBaseButton :text="linkText"
                          icon-after="IconRightFill"
                          icon-after-modify="icon-fill icon_color_blue"
                          modify="button_theme_reset" />
        </div>
    </router-link>
</template>

<script>
export default {
    name: 'NewsCard',

    props: {
        date    : String,
        tag     : String,
        title   : String,
        link    : String,
        linkText: {
            type   : String,
            default: 'Читать'
        },
        modify: [String, Array, Object]
    }
};
</script>

<style lang="scss">
@import "NewsCard";
</style>
